import fetch from './fetch'
import { urlPerfix, urlPerfixV2 } from '@/config/env'

// 获取验证码
export const mobileCode = phone => fetch(urlPerfix + '/verify_code', {
  token_validate: false,
  phone_number: phone,
}, 'GET');

// 登录
export const mobileLoginPost = (mobile, captcha, password = '') => fetch(urlPerfix + '/mobile_login', {
  token_validate: false,
  mobile: mobile,
  code: captcha,
}, 'POST');
export const passwdLoginPost = data => fetch(urlPerfix + '/password_login', data, 'POST');

// 获取验证码信息
export const getCaptcha = () => fetch(urlPerfix + '/captcha', {
  token_validate: false
}, "GET")


export const fileExport = data => fetch(urlPerfix + '/files/export', data)

export const messageList = data => fetch(urlPerfix + '/messages', data)
export const messageTypes = () => fetch(urlPerfix + '/messages/types')

// 用户
export const userList = data => fetch(urlPerfix + '/users', data)
export const userNew = data => fetch(urlPerfix + '/users', data, 'POST')
export const userDetail = id => fetch(urlPerfix + '/users/' + id)
export const userUpdate = data => fetch(urlPerfix + '/users/' + data.id, data, "PUT")
export const switchUserStatus = id => fetch(urlPerfix + `/users/${id}/status`, {}, 'POST')
export const userSet = data => fetch(urlPerfix + `/users/${data.id}/set`, data, 'POST')
export const resetUserPassword = id => fetch(urlPerfix + `/users/${id}/reset_password`, {}, 'POST')

// 角色
export const roleList = data => fetch(urlPerfix + '/roles', data)
export const createOrUpdateRole = data => fetch(urlPerfix + '/roles', data, 'POST')
export const deleteRole = id => fetch(urlPerfix + '/roles/' + id, {}, 'DELETE')
export const swtichRoleStatus = id => fetch(urlPerfix + '/roles/status/' + id, {}, 'POST')
export const authList = () => fetch(urlPerfix + '/auths')

// 基地设置
export const baseList = data => fetch(urlPerfix + '/bases', data)
export const baseCreate = data => fetch(urlPerfix + '/bases', data, 'POST')
export const baseUpdate = data => fetch(urlPerfix + '/bases/' + data.id, data, 'PUT')
export const switchBaseStatus = id => fetch(urlPerfix + `/bases/${id}/status`, {}, 'POST')


// 配件分类
export const itemTemplateList = data => fetch(urlPerfix + '/item_templates', data)
export const itemTemplateNew = data => fetch(urlPerfix + '/item_templates', data, 'POST')
export const itemTemplateDetail = id => fetch(urlPerfix + '/item_templates/' + id)
export const itemTemplateUpdate = data => fetch(urlPerfix + '/item_templates/' + data.id, data, 'PUT')
export const itemTemplateDelete = id => fetch(urlPerfix + '/item_templates/' + id, {}, 'DELETE')
export const itemTemplateAgeAnalyzeList = data => fetch(urlPerfix + '/item_templates/' + data.id + '/age_analyze', data)
export const itemTemplateRepairAnalyzeList = data => fetch(urlPerfix + '/item_templates/' + data.id + '/repair_analyze', data)
export const itemTemplateSort = data => fetch(urlPerfix + '/item_templates/sort', data, 'POST')
export const itemTemplateInventoryStatistic = data => fetch(urlPerfix + '/item_templates/' + data.id + '/inventory_statistic', data)

// 配件
export const itemList = data => fetch(urlPerfix + '/items', data)
export const itemNew = data => fetch(urlPerfix + '/items', data, 'POST')
export const itemDetail = id => fetch(urlPerfix + '/items/' + id)
export const itemUpdate = data => fetch(urlPerfix + '/items/' + data.id, data, 'PUT')
export const itemScrap = data => fetch(urlPerfix + '/items/scrap', data, 'POST')
export const itemDelete = id => fetch(urlPerfix + '/items/' + id, {}, 'DELETE')
export const itemStockOut = data => fetch(urlPerfix + '/items/stock_out/' + data.id, data, 'POST')
export const itemStockIn = data => fetch(urlPerfix + '/items/stock_in/' + data.id, data, 'POST')
export const itemUpdateDrillWell = data => fetch(urlPerfix + '/items/drill_well/' + data.id, data, 'POST')
export const itemReceiveComfirm = data => fetch(urlPerfix + '/items/receive_confirm/' + data.id, data, 'POST')
export const itemRecall = data => fetch(urlPerfix + '/items/recall/' + data.id, data, 'POST')
export const itemReject = data => fetch(urlPerfix + '/items/reject/' + data.id, data, 'POST')

//配件库存分布
export const itemInventoryList = data => fetch(urlPerfix + '/item_inventories', data)

// 配件记录
export const itemRecordList = data => fetch(urlPerfix + '/item_records', data)
export const itemRecordNew = data => fetch(urlPerfix + '/item_records', data, 'POST')
export const itemRecordUpdate = data => fetch(urlPerfix + '/item_records/' + data.id, data, 'PUT')
export const itemRecordDelete = id => fetch(urlPerfix + '/item_records/' + id, {}, 'DELETE')

// 成品分类分组
export const templateGroupList = data => fetch(urlPerfix + '/template_groups', data)
export const templateGroupNew = data => fetch(urlPerfix + '/template_groups', data, 'POST')
export const templateGroupUpdate = data => fetch(urlPerfix + '/template_groups/' + data.id, data, 'PUT')
export const templateGroupDelete = id => fetch(urlPerfix + '/template_groups/' + id, {}, 'DELETE')
export const templateGroupSort = data => fetch(urlPerfix + '/template_groups/sort', data, 'POST')

// 成品分类
export const productTemplateList = data => fetch(urlPerfix + '/product_templates', data)
export const productTemplateNew = data => fetch(urlPerfix + '/product_templates', data, 'POST')
export const productTemplateDetail = id => fetch(urlPerfix + '/product_templates/' + id)
export const productTemplateUpdate = data => fetch(urlPerfix + '/product_templates/' + data.id, data, 'PUT')
export const productTemplateDelete = id => fetch(urlPerfix + '/product_templates/' + id, {}, 'DELETE')
export const productTemplateSort = data => fetch(urlPerfix + '/product_templates/sort', data, 'POST')

// 成品列表
export const productList = data => fetch(urlPerfix + '/products', data)
export const productNew = data => fetch(urlPerfix + '/products', data, 'POST')
export const productDetail = id => fetch(urlPerfix + '/products/' + id)
export const productUpdate = data => fetch(urlPerfix + '/products/' + data.id, data, 'PUT')
export const productDelete = id => fetch(urlPerfix + '/products/' + id, {}, 'DELETE')
export const productFinishInstall = data => fetch(urlPerfix + '/products/' + data.id + '/install', data, 'POST')
export const productDisassemble = data => fetch(urlPerfix + '/products/' + data.id + '/disassemble', data, 'POST')
export const productDisassembleV2 = data => fetch(urlPerfixV2 + '/products/' + data.id + '/disassemble', data, 'POST')
export const productStockOut = data => fetch(urlPerfix + '/products/' + data.id + '/stock_out', data, 'POST')
export const productStockIn = data => fetch(urlPerfix + '/products/' + data.id + '/stock_in', data, 'POST')
export const productUpdateDrillWell = data => fetch(urlPerfix + '/products/' + data.id + '/drill_well', data, 'POST')
export const productReceiveComfirm = data => fetch(urlPerfix + '/products/' + data.id + '/receive_confirm', data, 'POST')
export const productScrap = data => fetch(urlPerfix + '/products/0/scrap', data, 'POST')
export const productUpdateNumber = data => fetch(urlPerfix + '/products/' + data.id + '/number', data, 'POST')
export const productRecall = data => fetch(urlPerfix + '/products/' + data.id + '/recall', data, 'POST')
export const productReject = data => fetch(urlPerfix + '/products/' + data.id + '/reject', data, 'POST')
export const productBatchDisassemble = data => fetch(urlPerfix + '/products/0/batch_disassemble', data, 'POST')


//成品库存分布
export const productInventoryList = data => fetch(urlPerfix + '/product_inventories', data)

// 成品操作记录
export const productRecordList = data => fetch(urlPerfix + '/product_records', data)
export const productRecordNew = data => fetch(urlPerfix + '/product_records', data, 'POST')
export const productRecordUpdate = data => fetch(urlPerfix + '/product_records/' + data.id, data, 'PUT')
export const productRecordDelete = id => fetch(urlPerfix + '/product_records/' + id, {}, 'DELETE')

//成品在钻井使用记录
export const productWellPeriodList = data => fetch(urlPerfix + '/product_well_periods', data)

// 成品配件
export const productItemNew = data => fetch(urlPerfix + '/product_items', data, 'POST')
export const productItemUpdate = data => fetch(urlPerfix + '/product_items/' + data.id, data, 'PUT')
export const productItemDisassemble = data => fetch(urlPerfix + '/product_items/' + data.id + '/disassemble', data, 'POST')
export const productItemDelete = id => fetch(urlPerfix + '/product_items/' + id, {}, 'DELETE')

//钻井管理
export const drillWellList = data => fetch(urlPerfix + '/drill_wells', data)
export const drillWellNew = data => fetch(urlPerfix + '/drill_wells', data, 'POST')
export const drillWellDetail = id => fetch(urlPerfix + '/drill_wells/' + id)
export const drillWellUpdate = data => fetch(urlPerfix + '/drill_wells/' + data.id, data, 'PUT')
export const drillWellDelete = id => fetch(urlPerfix + '/drill_wells/' + id, {}, 'DELETE')
export const drillWellDeleteStatus = data => fetch(urlPerfix + '/drill_wells/' + data.id + '/status', data, 'POST')
export const drillWellReceiving = data => fetch(urlPerfix + '/drill_wells/' + data.id + '/receiving', data)

// 钻井仪器串管理
export const productGroupList = data => fetch(urlPerfix + '/product_groups', data)
export const productGroupNew = data => fetch(urlPerfix + '/product_groups', data, 'POST')
export const productGroupUpdate = data => fetch(urlPerfix + '/product_groups/' + data.id, data, 'PUT')
export const productGroupDelete = id => fetch(urlPerfix + '/product_groups/' + id, {}, 'DELETE')

// 成品组件模板
export const productComponentTemplateList = data => fetch(urlPerfix + '/product_component_templates', data)
export const productComponentTemplateNew = data => fetch(urlPerfix + '/product_component_templates', data, 'POST')
export const productComponentTemplateUpdate = data => fetch(urlPerfix + '/product_component_templates/' + data.id, data, 'PUT')


//成品组件维修记录
export const productTemplateComponentRecordList = data => fetch(urlPerfix + '/product_template_component_records', data)


// 预警条件
export const templateWarningRuleList = data => fetch(urlPerfix + '/template_warning_rules', data)
export const templateWarningRuleNew = data => fetch(urlPerfix + '/template_warning_rules', data, 'POST')
export const templateWarningRuleUpdate = data => fetch(urlPerfix + '/template_warning_rules/' + data.id, data, 'PUT')
export const templateWarningRuleDelete = id => fetch(urlPerfix + '/template_warning_rules/' + id, {}, 'DELETE')

// 附件
export const attachmentList = data => fetch(urlPerfix + '/attachments', data)
export const attachmentNew = data => fetch(urlPerfix + '/attachments', data, 'POST')
export const attachmentDelete = id => fetch(urlPerfix + '/attachments/' + id, {}, 'DELETE')


// 物资调拨
export const applyList = data => fetch(urlPerfix + '/applies', data)
export const applyNew = data => fetch(urlPerfix + '/applies', data, 'POST')
export const applyUpdate = data => fetch(urlPerfix + '/applies/' + data.id, data, 'PUT')
export const applyDetail = data => fetch(urlPerfix + '/applies/' + data.id, data)
export const applyDelete = id => fetch(urlPerfix + '/applies/' + id, {}, 'DELETE')
export const applyStart = id => fetch(urlPerfix + '/applies/' + id + '/start', {}, 'POST')
export const applyApprove = data => fetch(urlPerfix + '/applies/' + data.id + '/approve', data, 'POST')
export const applyRecall = id => fetch(urlPerfix + '/applies/' + id + '/recall', {}, 'POST')
export const applyOption = data => fetch(urlPerfix + '/applies/' + data.id + '/option', data, 'POST')
export const applyItemOption = data => fetch(urlPerfix + '/applies/' + data.id + '/item_option', data, 'POST')

// 成品统计
export const productStatistics = data => fetch(urlPerfix + '/product_statistics', data)

//配件统计
export const itemStatistics = data => fetch(urlPerfix + '/item_statistics', data)

//导航栏数量通知
export const navBadgeData = () => fetch(urlPerfix + '/nav_badge')
